/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Date` scalar type represents a year, month and day in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  Date: { input: string; output: string; }
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: { input: string; output: string; }
  Guid: { input: string; output: string; }
  UInt: { input: number; output: number; }
};

export type AddressInput = {
  addressline1: Scalars['String']['input'];
  addressline2?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  postalcode: Scalars['String']['input'];
  stateProvice: Scalars['String']['input'];
};

export type AddressType = {
  __typename?: 'AddressType';
  /** The address */
  addressline1?: Maybe<Scalars['String']['output']>;
  /** The address */
  addressline2?: Maybe<Scalars['String']['output']>;
  /** The Id of the address. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The postalcode */
  postalcode?: Maybe<Scalars['String']['output']>;
  /** The state province */
  stateProvice?: Maybe<Scalars['String']['output']>;
};

export type BlastInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  crs?: InputMaybe<Scalars['Int']['input']>;
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inputX?: InputMaybe<Scalars['Float']['input']>;
  inputY?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalDocumentId?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
  subProjectNumber?: InputMaybe<Scalars['String']['input']>;
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type BlastType = {
  __typename?: 'BlastType';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crs: Scalars['Int']['output'];
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  /** The Id of the blast. */
  id: Scalars['Int']['output'];
  inputX?: Maybe<Scalars['Float']['output']>;
  inputY?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  journalDocumentId?: Maybe<Scalars['Int']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  subProjectNumber?: Maybe<Scalars['String']['output']>;
  z?: Maybe<Scalars['Float']['output']>;
};

export type BusinessLogCommentInput = {
  businessLogId?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessLogCommentType = {
  __typename?: 'BusinessLogCommentType';
  businessLogId: Scalars['Int']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type BusinessLogDataRowType = {
  __typename?: 'BusinessLogDataRowType';
  businessId?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentBusinessLogId?: Maybe<Scalars['Int']['output']>;
  commentCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  commentCreatedBy?: Maybe<Scalars['String']['output']>;
  commentCreatedByName?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['Int']['output']>;
  commentIsActive?: Maybe<Scalars['Boolean']['output']>;
  /** Comments on the measuring data */
  comments?: Maybe<Array<Maybe<BusinessLogCommentType>>>;
  fieldName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  objectName?: Maybe<Scalars['String']['output']>;
  operationTime?: Maybe<Scalars['DateTime']['output']>;
  operationType?: Maybe<Scalars['Int']['output']>;
  projectId?: Maybe<Scalars['Int']['output']>;
  sourceValue?: Maybe<Scalars['String']['output']>;
  tableName?: Maybe<Scalars['String']['output']>;
  targetValue?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type BusinessLogInput = {
  businessId?: InputMaybe<Scalars['Int']['input']>;
  comments?: InputMaybe<Array<InputMaybe<BusinessLogCommentInput>>>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  operationType?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  sourceValue?: InputMaybe<Scalars['String']['input']>;
  tableName?: InputMaybe<Scalars['String']['input']>;
  targetValue?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ChannelInput = {
  alarm?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['Int']['input'];
  hiredFrom?: InputMaybe<Scalars['DateTime']['input']>;
  hiredTo?: InputMaybe<Scalars['DateTime']['input']>;
  measuringPointId?: InputMaybe<Scalars['Int']['input']>;
  noBenchmark?: InputMaybe<Scalars['Boolean']['input']>;
  noiseHourlyAlarmEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  placement?: InputMaybe<Scalars['Int']['input']>;
  sensor?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ContactInput = {
  address?: InputMaybe<AddressInput>;
  customerId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  surName: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactType = {
  __typename?: 'ContactType';
  /** The address of the contact */
  address?: Maybe<AddressType>;
  customerId: Scalars['Int']['output'];
  /** The email of the contact. */
  email: Scalars['String']['output'];
  /** The firstname of the contact. */
  firstName: Scalars['String']['output'];
  /** The Id of the contact. */
  id: Scalars['Int']['output'];
  /** Is the contact active. */
  isActive: Scalars['Boolean']['output'];
  /** The name of the contact. */
  name: Scalars['String']['output'];
  /** The phone number of the contact. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The reference of the contact. */
  reference?: Maybe<Scalars['String']['output']>;
  /** The surname of the contact. */
  surName?: Maybe<Scalars['String']['output']>;
  /** The user info */
  user?: Maybe<UserInfoType>;
  /** User id */
  userId: Scalars['Int']['output'];
};

export type CustomerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressInput>;
  exportToQBIS: Scalars['Boolean']['input'];
  frameworkAgreement?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerType = {
  __typename?: 'CustomerType';
  /** If the customer is active. */
  active: Scalars['Boolean']['output'];
  /** The address of the customer */
  address?: Maybe<AddressType>;
  /** The contacts that belong to the customer */
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  /** The email of the customer. */
  email?: Maybe<Scalars['String']['output']>;
  exportToQBIS: Scalars['Boolean']['output'];
  /** The framework agreement of the customer. */
  frameworkAgreement?: Maybe<Scalars['String']['output']>;
  /** The Id of the customer. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The name of the customer. */
  name?: Maybe<Scalars['String']['output']>;
  /** The phonenumber of the customer. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The website of the customer. */
  website?: Maybe<Scalars['String']['output']>;
};

export type DeleteBlastInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteMeasuringPointInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection from an object to a list of objects of type `Document`. */
export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<DocumentEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<DocumentType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Document`. */
export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DocumentType>;
};

export type DocumentFolderType = {
  __typename?: 'DocumentFolderType';
  allowUploads: Scalars['Boolean']['output'];
  children?: Maybe<Array<Maybe<DocumentFolderType>>>;
  defaultVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type DocumentFoldersType = {
  __typename?: 'DocumentFoldersType';
  /** Default root level folders */
  root?: Maybe<Array<Maybe<TopLevelDocumentFolderType>>>;
};

export type DocumentType = {
  __typename?: 'DocumentType';
  /** The assignments associated with the document (bit pattern) */
  assignment: Scalars['Int']['output'];
  /** Any child documents associated with this download */
  children?: Maybe<Array<Maybe<DocumentType>>>;
  /** Date and time when the document was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Name and email of the document's creator */
  createdBy: Scalars['String']['output'];
  /** The daemon events for this file */
  events?: Maybe<Array<Maybe<EventType>>>;
  /** The document's filename */
  filename: Scalars['String']['output'];
  /** The Id of the document */
  id: Scalars['Int']['output'];
  /** Is document still active (used for soft deletes */
  isActive: Scalars['Boolean']['output'];
  /** The document's MIME type */
  mime: Scalars['String']['output'];
  /** Date and time when the document was last modified */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Name and email of the last user to modify the document */
  modifiedBy: Scalars['String']['output'];
  /** The document's path in the virtual file system */
  path: Scalars['String']['output'];
  /** The reference number of the project the document belongs to */
  projectReference: Scalars['String']['output'];
  /** The tags associated with the document */
  tags?: Maybe<Scalars['String']['output']>;
  /** The template this document was created from */
  template: Scalars['String']['output'];
  /** The document type */
  type: Scalars['String']['output'];
  /** Is this the child of another document */
  uploadChild: Scalars['Boolean']['output'];
  /** The Id associated with the document's upload */
  uploadId?: Maybe<Scalars['Guid']['output']>;
  /** The existing version of this file */
  versions?: Maybe<Array<Maybe<DocumentVersionType>>>;
};

export type DocumentVersionType = {
  __typename?: 'DocumentVersionType';
  basedOn?: Maybe<Scalars['String']['output']>;
  conflict: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type EventType = {
  __typename?: 'EventType';
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type ExplodeJournalCommentsInputType = {
  comment: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  explodeJournalId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type ExplodeJournalCommentsType = {
  __typename?: 'ExplodeJournalCommentsType';
  comment: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  explodeJournalId: Scalars['Int']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  /** The user info */
  user?: Maybe<UserInfoType>;
  userId: Scalars['Int']['output'];
};

export type ExplodeJournalInputType = {
  backwardDelay?: InputMaybe<Scalars['Float']['input']>;
  blastId?: InputMaybe<Scalars['Int']['input']>;
  chargeSpec?: InputMaybe<Scalars['Float']['input']>;
  continuance?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  drillMeter?: InputMaybe<Scalars['Float']['input']>;
  drillSpec?: InputMaybe<Scalars['Float']['input']>;
  explodeJournalComments?: InputMaybe<Array<InputMaybe<ExplodeJournalCommentsInputType>>>;
  explosiveMaterials?: InputMaybe<Array<InputMaybe<ExplosiveMaterialInputType>>>;
  holeDiameter?: InputMaybe<Scalars['Float']['input']>;
  holeNumber?: InputMaybe<Scalars['Int']['input']>;
  holeSlope?: InputMaybe<Scalars['Float']['input']>;
  holeSpacing?: InputMaybe<Scalars['Float']['input']>;
  /** The Id. */
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lightSystem?: InputMaybe<Scalars['String']['input']>;
  maxSamCharge?: InputMaybe<Scalars['Float']['input']>;
  mediumHoleDepth?: InputMaybe<Scalars['Float']['input']>;
  pageDelay?: InputMaybe<Scalars['Float']['input']>;
  rowNumber?: InputMaybe<Scalars['Int']['input']>;
  tonnage?: InputMaybe<Scalars['Float']['input']>;
  unchargedPart?: InputMaybe<Scalars['Float']['input']>;
  underDrill?: InputMaybe<Scalars['Float']['input']>;
  vibrationResult?: InputMaybe<Scalars['Float']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

export type ExplodeJournalType = {
  __typename?: 'ExplodeJournalType';
  backwardDelay?: Maybe<Scalars['Float']['output']>;
  blastId: Scalars['Int']['output'];
  chargeSpec?: Maybe<Scalars['Float']['output']>;
  comments?: Maybe<Array<Maybe<ExplodeJournalCommentsType>>>;
  continuance?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  drillMeter?: Maybe<Scalars['Float']['output']>;
  drillSpec?: Maybe<Scalars['Float']['output']>;
  explosiveMaterial?: Maybe<Array<Maybe<ExplosiveMaterialType>>>;
  holeDiameter?: Maybe<Scalars['Float']['output']>;
  holeNumber?: Maybe<Scalars['Int']['output']>;
  holeSlope?: Maybe<Scalars['Float']['output']>;
  holeSpacing?: Maybe<Scalars['Float']['output']>;
  /** The Id. */
  id?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  lightSystem?: Maybe<Scalars['String']['output']>;
  maxSamCharge?: Maybe<Scalars['Float']['output']>;
  mediumHoleDepth?: Maybe<Scalars['Float']['output']>;
  pageDelay?: Maybe<Scalars['Float']['output']>;
  rowNumber?: Maybe<Scalars['Int']['output']>;
  tonnage?: Maybe<Scalars['Float']['output']>;
  unchargedPart?: Maybe<Scalars['Float']['output']>;
  underDrill?: Maybe<Scalars['Float']['output']>;
  vibrationResult?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type ExplosiveMaterialInputType = {
  amount: Scalars['Float']['input'];
  explodeJournalId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  unit: Scalars['String']['input'];
};

export type ExplosiveMaterialType = {
  __typename?: 'ExplosiveMaterialType';
  amount: Scalars['Float']['output'];
  explodeJournalId: Scalars['Int']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  materialId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type ExportInvoiceParametersInput = {
  invoiceEndDate: Scalars['String']['input'];
  invoiceStartDate: Scalars['String']['input'];
  projects: Scalars['String']['input'];
};

export type FaqDocumentType = {
  __typename?: 'FaqDocumentType';
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  permission: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum FileAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Open = 'OPEN'
}

export type FileActionInput = {
  action?: InputMaybe<FileAction>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** A connection from an object to a list of objects of type `FredStatus`. */
export type FredStatusConnection = {
  __typename?: 'FredStatusConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<FredStatusEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<FredStatusType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `FredStatus`. */
export type FredStatusEdge = {
  __typename?: 'FredStatusEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FredStatusType>;
};

export type FredStatusType = {
  __typename?: 'FredStatusType';
  charset: Scalars['String']['output'];
  checksum: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['DateTime']['output']>;
  destination: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  measuringCard?: Maybe<MeasuringCardType>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['DateTime']['output']>;
  originator: Scalars['String']['output'];
  processed: Scalars['Boolean']['output'];
  project?: Maybe<Project>;
  text: Scalars['String']['output'];
  udh: Scalars['String']['output'];
};

export type InstrumentDataType = {
  __typename?: 'InstrumentDataType';
  /** Calibration date of the instrument */
  calibrationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The number of channels for this instrument */
  channels: Scalars['Int']['output'];
  /** Critical Errors Array */
  criticalErrors?: Maybe<Array<Scalars['Int']['output']>>;
  currentConfiguration?: Maybe<Scalars['String']['output']>;
  /** The id of the instrument. */
  id: Scalars['Int']['output'];
  /** Is this instrument currently active (used for soft deletes) */
  isActive: Scalars['Boolean']['output'];
  lastStatusAt?: Maybe<Scalars['DateTime']['output']>;
  latestLocation?: Maybe<InstrumentLocationDataType>;
  /** The instrument model */
  model: Scalars['String']['output'];
  /** The instrument's name */
  name: Scalars['String']['output'];
  nextConfiguration?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<Scalars['String']['output']>;
};

export type InstrumentInputType = {
  channels?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextConfiguration?: InputMaybe<Scalars['String']['input']>;
};

export type InstrumentLocationDataType = {
  __typename?: 'InstrumentLocationDataType';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  receivedAt: Scalars['DateTime']['output'];
};

export type InstrumentLocationType = {
  __typename?: 'InstrumentLocationType';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  receivedAt: Scalars['DateTime']['output'];
};

export type InstrumentType = {
  __typename?: 'InstrumentType';
  /** Calibration date of the instrument */
  calibrationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The number of channels for this instrument */
  channels: Scalars['Int']['output'];
  criticalErrors?: Maybe<Array<Scalars['Int']['output']>>;
  currentConfiguration?: Maybe<Scalars['String']['output']>;
  /** The id of the instrument. */
  id: Scalars['Int']['output'];
  /** Is this instrument currently active (used for soft deletes) */
  isActive: Scalars['Boolean']['output'];
  lastStatusAt?: Maybe<Scalars['DateTime']['output']>;
  latestLocation?: Maybe<InstrumentLocationType>;
  /** The instrument model */
  model: Scalars['String']['output'];
  /** The instrument's name */
  name: Scalars['String']['output'];
  nextConfiguration?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<Scalars['String']['output']>;
};

export type InvoiceExportLogType = {
  __typename?: 'InvoiceExportLogType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  invoiceEndDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceStartDate?: Maybe<Scalars['DateTime']['output']>;
  projects: Scalars['String']['output'];
};

export type InvoiceExportLogsType = {
  __typename?: 'InvoiceExportLogsType';
  logs?: Maybe<Array<Maybe<InvoiceExportLogType>>>;
};

export type InvoiceItemType = {
  __typename?: 'InvoiceItemType';
  channelType: Scalars['String']['output'];
  invoiceEndDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceStartDate?: Maybe<Scalars['DateTime']['output']>;
  kId: Scalars['String']['output'];
  measuringCardId: Scalars['Int']['output'];
  measuringCardName: Scalars['String']['output'];
  measuringCardValidFrom?: Maybe<Scalars['DateTime']['output']>;
  measuringCardValidTo?: Maybe<Scalars['DateTime']['output']>;
  measuringPointAddress: Scalars['String']['output'];
  measuringPointHiredFrom?: Maybe<Scalars['DateTime']['output']>;
  measuringPointHiredTo?: Maybe<Scalars['DateTime']['output']>;
  measuringPointId: Scalars['Int']['output'];
  measuringPointNumber: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  projectName: Scalars['String']['output'];
  projectReferenceNumber: Scalars['String']['output'];
};

export enum InvoiceItemsSortBy {
  ChannelType = 'CHANNEL_TYPE',
  MeasuringCardName = 'MEASURING_CARD_NAME',
  MeasuringCardValidFrom = 'MEASURING_CARD_VALID_FROM',
  MeasuringCardValidTo = 'MEASURING_CARD_VALID_TO',
  MeasuringPointAddress = 'MEASURING_POINT_ADDRESS',
  MeasuringPointNumber = 'MEASURING_POINT_NUMBER',
  ProjectName = 'PROJECT_NAME',
  ProjectReferenceNumber = 'PROJECT_REFERENCE_NUMBER'
}

export type LimitsInput = {
  channelId: Scalars['Int']['input'];
  dayLAEq?: InputMaybe<Scalars['Int']['input']>;
  dayLAFMax?: InputMaybe<Scalars['Int']['input']>;
  eveningLAEq?: InputMaybe<Scalars['Int']['input']>;
  eveningLAFMax?: InputMaybe<Scalars['Int']['input']>;
  holidayDayLAEq?: InputMaybe<Scalars['Int']['input']>;
  holidayDayLAFMax?: InputMaybe<Scalars['Int']['input']>;
  holidayEveningLAEq?: InputMaybe<Scalars['Int']['input']>;
  holidayEveningLAFMax?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nightLAEq?: InputMaybe<Scalars['Int']['input']>;
  nightLAFMax?: InputMaybe<Scalars['Int']['input']>;
};

export type LimitsType = {
  __typename?: 'LimitsType';
  channelId?: Maybe<Scalars['Int']['output']>;
  dayLAEq?: Maybe<Scalars['Int']['output']>;
  dayLAFMax?: Maybe<Scalars['Int']['output']>;
  eveningLAEq?: Maybe<Scalars['Int']['output']>;
  eveningLAFMax?: Maybe<Scalars['Int']['output']>;
  holidayDayLAEq?: Maybe<Scalars['Int']['output']>;
  holidayDayLAFMax?: Maybe<Scalars['Int']['output']>;
  holidayEveningLAEq?: Maybe<Scalars['Int']['output']>;
  holidayEveningLAFMax?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  nightLAEq?: Maybe<Scalars['Int']['output']>;
  nightLAFMax?: Maybe<Scalars['Int']['output']>;
};

export type ListBusinessLogDataType = {
  __typename?: 'ListBusinessLogDataType';
  businessLogData?: Maybe<Array<Maybe<BusinessLogDataRowType>>>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
};

export type ListInvoiceItemsType = {
  __typename?: 'ListInvoiceItemsType';
  hasNextPage: Scalars['Boolean']['output'];
  invoiceItemsData?: Maybe<Array<Maybe<InvoiceItemType>>>;
};

export type ListMeasuringDataType = {
  __typename?: 'ListMeasuringDataType';
  hasNextPage: Scalars['Boolean']['output'];
  measuringData?: Maybe<Array<Maybe<MeasuringDataRowType>>>;
};

export type ListSentNotificationOutputType = {
  __typename?: 'ListSentNotificationOutputType';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  notificationData?: Maybe<Array<Maybe<SentNotificationType>>>;
};

export type MeasuringCardChannelType = {
  __typename?: 'MeasuringCardChannelType';
  alarm?: Maybe<Scalars['String']['output']>;
  channel: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['String']['output'];
  hiredFrom?: Maybe<Scalars['DateTime']['output']>;
  hiredTo?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  measuringCardId: Scalars['Int']['output'];
  measuringPoint?: Maybe<MeasuringPointType>;
  measuringPointId?: Maybe<Scalars['Int']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy: Scalars['String']['output'];
  noBenchmark: Scalars['Boolean']['output'];
  noiseHourlyAlarmEnabled: Scalars['Boolean']['output'];
  placement?: Maybe<Scalars['Int']['output']>;
  sensor?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MeasuringCardInput = {
  channels?: InputMaybe<Array<InputMaybe<ChannelInput>>>;
  correction?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instrument: Scalars['String']['input'];
  noService: Scalars['Boolean']['input'];
  projectId: Scalars['Int']['input'];
  unMount: Scalars['Boolean']['input'];
  validFrom: Scalars['DateTime']['input'];
  validTo: Scalars['DateTime']['input'];
};

export type MeasuringCardType = {
  __typename?: 'MeasuringCardType';
  allChannelsOK: Scalars['Boolean']['output'];
  batteryDaysLeft?: Maybe<Scalars['UInt']['output']>;
  /** The channel setup for this measuring card */
  channels?: Maybe<Array<Maybe<MeasuringCardChannelType>>>;
  channelsStatus?: Maybe<Scalars['String']['output']>;
  correction?: Maybe<Scalars['Int']['output']>;
  /** The Id of the measuring card. */
  id: Scalars['Int']['output'];
  /** The instrument used in this measuring card */
  instrument?: Maybe<InstrumentType>;
  /** Instrument's last reported battery voltage */
  instrumentBattery?: Maybe<Scalars['Float']['output']>;
  /** Instruments' last reported memory card capacity */
  instrumentCapacity?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastNumber: Scalars['Int']['output'];
  /** When the instrument last reported status */
  lastStatusActivity?: Maybe<Scalars['DateTime']['output']>;
  /** When the instrument last reported trigger */
  lastTriggerActivity?: Maybe<Scalars['DateTime']['output']>;
  noService: Scalars['Boolean']['output'];
  rssi?: Maybe<Scalars['Int']['output']>;
  statusErrorReasons?: Maybe<Scalars['String']['output']>;
  triggerErrorReasons?: Maybe<Scalars['String']['output']>;
  unMount: Scalars['Boolean']['output'];
  /** Start date for the card's valid interval */
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validSetup: Scalars['Boolean']['output'];
  /** Start date for the card's valid interval */
  validTo?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};


export type MeasuringCardTypeChannelsArgs = {
  measuringCardChannelType?: InputMaybe<Scalars['String']['input']>;
};

export type MeasuringDataCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  measuringDataId?: InputMaybe<Scalars['Int']['input']>;
};

export type MeasuringDataCommentType = {
  __typename?: 'MeasuringDataCommentType';
  comment: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['String']['output'];
  createdByName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  measuringDataId: Scalars['Int']['output'];
};

/** A connection from an object to a list of objects of type `MeasuringData`. */
export type MeasuringDataConnection = {
  __typename?: 'MeasuringDataConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<MeasuringDataEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<MeasuringDataType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `MeasuringData`. */
export type MeasuringDataEdge = {
  __typename?: 'MeasuringDataEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MeasuringDataType>;
};

export type MeasuringDataRowType = {
  __typename?: 'MeasuringDataRowType';
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  benchmark: Scalars['String']['output'];
  blastComment?: Maybe<Scalars['String']['output']>;
  blastId?: Maybe<Scalars['Int']['output']>;
  blastName?: Maybe<Scalars['String']['output']>;
  blastSubProjectNumber?: Maybe<Scalars['String']['output']>;
  channelType: Scalars['String']['output'];
  colour: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  commentCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  commentCreatedBy?: Maybe<Scalars['String']['output']>;
  commentCreatedByName?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['Int']['output']>;
  commentIsActive?: Maybe<Scalars['Boolean']['output']>;
  commentMeasuringDataId?: Maybe<Scalars['Int']['output']>;
  /** Comments on the measuring data */
  comments?: Maybe<Array<Maybe<MeasuringDataCommentType>>>;
  distance?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Float']['output']>;
  hasCurve: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isService: Scalars['Boolean']['output'];
  measuringPointId: Scalars['Int']['output'];
  measuringPointTitle: Scalars['String']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['Int']['output']>;
  number: Scalars['Float']['output'];
  percentOfBenchmark?: Maybe<Scalars['Float']['output']>;
  projectReference: Scalars['String']['output'];
  received?: Maybe<Scalars['DateTime']['output']>;
  sFrequency: Scalars['String']['output'];
  sReceived: Scalars['String']['output'];
  sV10: Scalars['String']['output'];
  sValue: Scalars['String']['output'];
  showCurve: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  v10?: Maybe<Scalars['Int']['output']>;
  value: Scalars['Float']['output'];
};

export enum MeasuringDataSortBy {
  ArrivedAt = 'ARRIVED_AT',
  Benchmark = 'BENCHMARK',
  BlastName = 'BLAST_NAME',
  BlastSubProjectNumber = 'BLAST_SUB_PROJECT_NUMBER',
  Distance = 'DISTANCE',
  Frequency = 'FREQUENCY',
  Id = 'ID',
  MeasuringPointTitle = 'MEASURING_POINT_TITLE',
  PercentOfBenchmark = 'PERCENT_OF_BENCHMARK',
  Received = 'RECEIVED',
  Value = 'VALUE',
  V_10 = 'V_10'
}

export type MeasuringDataType = {
  __typename?: 'MeasuringDataType';
  benchmark: Scalars['String']['output'];
  blastBenchmark?: Maybe<Scalars['Int']['output']>;
  blastColour?: Maybe<Scalars['String']['output']>;
  blastComment?: Maybe<Scalars['String']['output']>;
  blastDistance?: Maybe<Scalars['Int']['output']>;
  blastId?: Maybe<Scalars['Int']['output']>;
  channelId: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  colour: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  commentCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  commentCreatedBy?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['Int']['output']>;
  commentIsActive?: Maybe<Scalars['Boolean']['output']>;
  commentMeasuringDataId?: Maybe<Scalars['Int']['output']>;
  /** Comments on the measuring data */
  comments?: Maybe<Array<Maybe<MeasuringDataCommentType>>>;
  curveData?: Maybe<Scalars['String']['output']>;
  curveHash?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Float']['output']>;
  hasCurve: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  measuringCardChannel?: Maybe<MeasuringCardChannelType>;
  measuringCardId: Scalars['Int']['output'];
  measuringPoint?: Maybe<MeasuringPointType>;
  measuringPointId: Scalars['Int']['output'];
  measuringPointTitle: Scalars['String']['output'];
  projectReference: Scalars['String']['output'];
  received?: Maybe<Scalars['DateTime']['output']>;
  showCurve: Scalars['Boolean']['output'];
  sigicomData?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  v10?: Maybe<Scalars['Int']['output']>;
  value: Scalars['Float']['output'];
};

export type MeasuringPointImageType = {
  __typename?: 'MeasuringPointImageType';
  created: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  imageDocumentId: Scalars['Int']['output'];
  measuringPointId: Scalars['Int']['output'];
};

export type MeasuringPointInput = {
  acceleration?: InputMaybe<Scalars['Float']['input']>;
  address: Scalars['String']['input'];
  airblast?: InputMaybe<Scalars['Float']['input']>;
  crs?: InputMaybe<Scalars['Int']['input']>;
  distanceMax?: InputMaybe<Scalars['Float']['input']>;
  distanceMin?: InputMaybe<Scalars['Float']['input']>;
  fixedBenchmark?: InputMaybe<Scalars['Float']['input']>;
  highlightBenchmark?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imageDocumentId?: InputMaybe<Scalars['Int']['input']>;
  inputX?: InputMaybe<Scalars['Float']['input']>;
  inputY?: InputMaybe<Scalars['Float']['input']>;
  isAddedOnMap?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mountedInside?: InputMaybe<Scalars['Boolean']['input']>;
  mountedInsideNumber?: InputMaybe<Scalars['String']['input']>;
  needToRecalculate?: InputMaybe<Scalars['Boolean']['input']>;
  noBenchmark?: InputMaybe<Scalars['Boolean']['input']>;
  noise?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['Float']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
  sendAlarm?: InputMaybe<Scalars['Boolean']['input']>;
  showCurve?: InputMaybe<Scalars['Boolean']['input']>;
  typeOfWork: Scalars['String']['input'];
  underground?: InputMaybe<Scalars['String']['input']>;
  unknownBenchmark?: InputMaybe<Scalars['Boolean']['input']>;
  v10?: InputMaybe<Scalars['Float']['input']>;
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type MeasuringPointType = {
  __typename?: 'MeasuringPointType';
  acceleration?: Maybe<Scalars['Float']['output']>;
  address: Scalars['String']['output'];
  airblast?: Maybe<Scalars['Float']['output']>;
  benchMarkChanged?: Maybe<Scalars['Boolean']['output']>;
  crs?: Maybe<Scalars['Int']['output']>;
  distanceMax?: Maybe<Scalars['Float']['output']>;
  distanceMin?: Maybe<Scalars['Float']['output']>;
  fixedBenchmark?: Maybe<Scalars['Float']['output']>;
  highlightBenchmark?: Maybe<Scalars['Float']['output']>;
  /** The Id of the measuring point. */
  id: Scalars['Int']['output'];
  inputX?: Maybe<Scalars['Float']['output']>;
  inputY?: Maybe<Scalars['Float']['output']>;
  instrumentNumberChanged?: Maybe<Scalars['Boolean']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAddedOnMap?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** images attached to the measuring point */
  measuringPointImages: Array<MeasuringPointImageType>;
  mountedInside?: Maybe<Scalars['Boolean']['output']>;
  mountedInsideNumber?: Maybe<Scalars['String']['output']>;
  noBenchmark?: Maybe<Scalars['Boolean']['output']>;
  noise?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['Float']['output'];
  positionChanged?: Maybe<Scalars['Boolean']['output']>;
  projectId: Scalars['Int']['output'];
  showCurve?: Maybe<Scalars['Boolean']['output']>;
  typeOfWork: Scalars['String']['output'];
  underGroundChanged?: Maybe<Scalars['Boolean']['output']>;
  underground?: Maybe<Scalars['String']['output']>;
  unknownBenchmark?: Maybe<Scalars['Boolean']['output']>;
  v0?: Maybe<Scalars['Int']['output']>;
  v1?: Maybe<Scalars['Int']['output']>;
  v2?: Maybe<Scalars['Int']['output']>;
  v10?: Maybe<Scalars['Float']['output']>;
  z?: Maybe<Scalars['Float']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createBlast?: Maybe<Scalars['Int']['output']>;
  createMeasuringPoint?: Maybe<Scalars['Boolean']['output']>;
  createProject?: Maybe<Scalars['Int']['output']>;
  createProjectNote?: Maybe<Scalars['Boolean']['output']>;
  createUpdateBusinessLogComment?: Maybe<Scalars['Boolean']['output']>;
  createUpdateContact?: Maybe<Scalars['Int']['output']>;
  createUpdateCustomer?: Maybe<Scalars['Boolean']['output']>;
  createUpdateExplodeJournal?: Maybe<Scalars['Boolean']['output']>;
  createUpdateInstrument?: Maybe<Scalars['Boolean']['output']>;
  createUpdateMeasuringDataComment?: Maybe<Scalars['Boolean']['output']>;
  createUpdateMeasuringPoint?: Maybe<Scalars['Boolean']['output']>;
  createUpdateNoiseSetting?: Maybe<Scalars['Boolean']['output']>;
  createUpdateProjectNotification?: Maybe<Scalars['Boolean']['output']>;
  createUpdateProjectUser?: Maybe<Scalars['Int']['output']>;
  createUpdateUser?: Maybe<Scalars['Boolean']['output']>;
  createUserInvitation: Scalars['String']['output'];
  deleteBlast?: Maybe<Scalars['Boolean']['output']>;
  deleteBusinessLog?: Maybe<Scalars['Int']['output']>;
  deleteCustomer?: Maybe<Scalars['Boolean']['output']>;
  deleteExplodeJournal?: Maybe<Scalars['Int']['output']>;
  deleteMeasuringPoint?: Maybe<Scalars['Boolean']['output']>;
  deleteProjectNote?: Maybe<Scalars['Boolean']['output']>;
  deleteProjectNotification?: Maybe<Scalars['Boolean']['output']>;
  deleteProjectUser?: Maybe<Scalars['Boolean']['output']>;
  deleteRestoreProject?: Maybe<Scalars['Boolean']['output']>;
  deleteRestoreUser?: Maybe<Scalars['Boolean']['output']>;
  exportDevice?: Maybe<Scalars['Boolean']['output']>;
  exportInvoiceItems?: Maybe<Scalars['Boolean']['output']>;
  exportProject?: Maybe<Scalars['Boolean']['output']>;
  favouriteProject?: Maybe<Scalars['Int']['output']>;
  generateProjectAPIKey: Scalars['Int']['output'];
  recalculateMeasuringData?: Maybe<Scalars['String']['output']>;
  restoreBusinessLog?: Maybe<Scalars['Int']['output']>;
  scrubPersonalInfo?: Maybe<Scalars['Boolean']['output']>;
  sendFileAction?: Maybe<Scalars['Boolean']['output']>;
  sendSms?: Maybe<Scalars['String']['output']>;
  sendUserInvitation?: Maybe<Scalars['Boolean']['output']>;
  unfavouriteProject?: Maybe<Scalars['Int']['output']>;
  updateBlast?: Maybe<Scalars['Boolean']['output']>;
  updateChannelReduction?: Maybe<Scalars['Int']['output']>;
  updateCoordinatesForProject?: Maybe<Scalars['Boolean']['output']>;
  updateDocument?: Maybe<Scalars['Int']['output']>;
  updateDocumentStatus?: Maybe<Scalars['Int']['output']>;
  updateImageGallery?: Maybe<Scalars['Int']['output']>;
  updateMeasuringCard?: Maybe<Scalars['Int']['output']>;
  updateMeasuringData?: Maybe<Scalars['String']['output']>;
  updateProfile?: Maybe<Scalars['Boolean']['output']>;
  updateProject?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationCreateBlastArgs = {
  blast: BlastInput;
};


export type MutationCreateMeasuringPointArgs = {
  measuringPoint: MeasuringPointInput;
};


export type MutationCreateProjectArgs = {
  project: ProjectInput;
};


export type MutationCreateProjectNoteArgs = {
  note: NoteInput;
};


export type MutationCreateUpdateBusinessLogCommentArgs = {
  businessLogInput: BusinessLogInput;
};


export type MutationCreateUpdateContactArgs = {
  contactInput: ContactInput;
};


export type MutationCreateUpdateCustomerArgs = {
  customerInput: CustomerInput;
};


export type MutationCreateUpdateExplodeJournalArgs = {
  explodeJournalInput: ExplodeJournalInputType;
};


export type MutationCreateUpdateInstrumentArgs = {
  instrumentInput: InstrumentInputType;
};


export type MutationCreateUpdateMeasuringDataCommentArgs = {
  measuringDataCommentInput: MeasuringDataCommentInput;
};


export type MutationCreateUpdateMeasuringPointArgs = {
  measuringPoint: MeasuringPointInput;
};


export type MutationCreateUpdateNoiseSettingArgs = {
  noiseSettingInput: NoiseSettingInputType;
};


export type MutationCreateUpdateProjectNotificationArgs = {
  projectNotification: ProjectNotificationInput;
};


export type MutationCreateUpdateProjectUserArgs = {
  projectUserInput: ProjectUserInput;
};


export type MutationCreateUpdateUserArgs = {
  user: UserInput;
};


export type MutationCreateUserInvitationArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationDeleteBlastArgs = {
  blast: DeleteBlastInput;
};


export type MutationDeleteBusinessLogArgs = {
  logId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
};


export type MutationDeleteExplodeJournalArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteMeasuringPointArgs = {
  measuringPoint: DeleteMeasuringPointInput;
};


export type MutationDeleteProjectNoteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteProjectNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteProjectUserArgs = {
  projectId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationDeleteRestoreProjectArgs = {
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
};


export type MutationDeleteRestoreUserArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
};


export type MutationExportDeviceArgs = {
  isNew: Scalars['Boolean']['input'];
  measuringCardId: Scalars['Int']['input'];
};


export type MutationExportInvoiceItemsArgs = {
  exportInvoiceParameters: ExportInvoiceParametersInput;
};


export type MutationExportProjectArgs = {
  isNew: Scalars['Boolean']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationFavouriteProjectArgs = {
  id: Scalars['Int']['input'];
};


export type MutationGenerateProjectApiKeyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRecalculateMeasuringDataArgs = {
  blastId: Scalars['Int']['input'];
  measuringDataId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  sendAlarm: Scalars['Boolean']['input'];
};


export type MutationRestoreBusinessLogArgs = {
  logId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationScrubPersonalInfoArgs = {
  scrubPersonalInfo: ScrubPersonalInfoInput;
};


export type MutationSendFileActionArgs = {
  fileAction: FileActionInput;
};


export type MutationSendSmsArgs = {
  destination: Scalars['String']['input'];
  emailDestination: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};


export type MutationSendUserInvitationArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationUnfavouriteProjectArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUpdateBlastArgs = {
  blast: BlastInput;
};


export type MutationUpdateChannelReductionArgs = {
  channelId: Scalars['Int']['input'];
  reductionId: Scalars['Int']['input'];
};


export type MutationUpdateCoordinatesForProjectArgs = {
  updateCoordinatesForProject: UpdateCoordinatesForProjectInput;
};


export type MutationUpdateDocumentArgs = {
  filename: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  path: Scalars['String']['input'];
  projectReference: Scalars['String']['input'];
};


export type MutationUpdateDocumentStatusArgs = {
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
};


export type MutationUpdateImageGalleryArgs = {
  id: Scalars['Int']['input'];
  path: Scalars['String']['input'];
  projectReference: Scalars['String']['input'];
  tags?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMeasuringCardArgs = {
  measuringCard: MeasuringCardInput;
};


export type MutationUpdateMeasuringDataArgs = {
  frequency?: InputMaybe<Scalars['Float']['input']>;
  isService?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  measuringDataId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateProfileArgs = {
  profile: ProfileInput;
};


export type MutationUpdateProjectArgs = {
  project: ProjectInput;
};

export type NoiseDataType = {
  __typename?: 'NoiseDataType';
  channelId: Scalars['Int']['output'];
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  lEq?: Maybe<Scalars['Float']['output']>;
  lMax?: Maybe<Scalars['Float']['output']>;
  measuringCardId: Scalars['Int']['output'];
  sampleTime?: Maybe<Scalars['Int']['output']>;
};

export type NoiseDateSummariesType = {
  __typename?: 'NoiseDateSummariesType';
  hasNextPage: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  limits?: Maybe<LimitsType>;
  reduction: Scalars['Int']['output'];
  summaries?: Maybe<Array<Maybe<SummariesType>>>;
};

export type NoiseIntervalInputType = {
  channelId: Scalars['Int']['input'];
  endHour: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  intervalType: Scalars['Int']['input'];
  penalty: Scalars['Float']['input'];
  startHour: Scalars['Int']['input'];
};

export type NoiseIntervalType = {
  __typename?: 'NoiseIntervalType';
  /** Id of channel */
  channelId: Scalars['Int']['output'];
  endHour: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Interval type, 0=Day, 1=Evening,2=Night */
  intervalType: Scalars['Int']['output'];
  penalty: Scalars['Float']['output'];
  startHour: Scalars['Int']['output'];
};

export type NoiseSettingInputType = {
  intervals?: InputMaybe<Array<InputMaybe<NoiseIntervalInputType>>>;
  noiseLimit: LimitsInput;
};

export type NoiseSettingType = {
  __typename?: 'NoiseSettingType';
  intervals?: Maybe<Array<Maybe<NoiseIntervalType>>>;
  noiseLimit?: Maybe<LimitsType>;
};

export type NoteInput = {
  note: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type OfficeType = {
  __typename?: 'OfficeType';
  /** The address of the office */
  address?: Maybe<AddressType>;
  /** The Id of the office. */
  id: Scalars['Int']['output'];
  /** If the office is active */
  isActive: Scalars['Boolean']['output'];
  /** The Name of the office */
  name?: Maybe<Scalars['String']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ProfileInput = {
  email: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phonenumber?: InputMaybe<Scalars['String']['input']>;
};

export type Project = {
  __typename?: 'Project';
  /** The project agreement number */
  agreementNumber?: Maybe<Scalars['String']['output']>;
  /** If User can add/edit blast */
  allowModifyBlast: Scalars['Boolean']['output'];
  apiInUse: Scalars['Boolean']['output'];
  apiKey?: Maybe<Scalars['String']['output']>;
  /** The assistant */
  assistant?: Maybe<UserInfoType>;
  /** The reference number for an associated project */
  associatedProject?: Maybe<Scalars['String']['output']>;
  /** The blasts that belong to the project */
  blasts?: Maybe<Array<Maybe<BlastType>>>;
  /** The project budget */
  budget?: Maybe<Scalars['Int']['output']>;
  /** The contact */
  contact?: Maybe<UserInfoType>;
  /** The county the project will be active in */
  county?: Maybe<Scalars['String']['output']>;
  /** The date and time when the project was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The default Coordinate Reference System used in project */
  crs: Scalars['Int']['output'];
  /** The customer */
  customer?: Maybe<CustomerType>;
  /**
   * A description of the project
   * @deprecated Not used.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The documents associated with this project */
  documents?: Maybe<DocumentConnection>;
  /** The date the project will end */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The Id of the project. */
  id: Scalars['Int']['output'];
  /** Is this project active? */
  isActive: Scalars['Boolean']['output'];
  /** If the project is a favourite */
  isFavourite: Scalars['Boolean']['output'];
  /** If User is a property owner */
  isPropertyOwner: Scalars['Boolean']['output'];
  /** The default Latitude used in project */
  latitude?: Maybe<Scalars['Float']['output']>;
  listMeasuringData?: Maybe<ListMeasuringDataType>;
  /** The local manager */
  localManager?: Maybe<UserInfoType>;
  /** The default Longitude used in project */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Should contactPersons be able to manage blasts for this project? */
  manageBlasts?: Maybe<Scalars['Boolean']['output']>;
  /** The measuring card that belong to the project */
  measuringCards?: Maybe<Array<Maybe<MeasuringCardType>>>;
  measuringData?: Maybe<MeasuringDataConnection>;
  /** The measuring points that belong to the project */
  measuringPoints?: Maybe<Array<Maybe<MeasuringPointType>>>;
  /** The name of the project. */
  name: Scalars['String']['output'];
  noiseDateSummaries?: Maybe<NoiseDateSummariesType>;
  notes?: Maybe<Array<Maybe<ProjectNoteType>>>;
  /** The office */
  office?: Maybe<OfficeType>;
  projectUsers?: Maybe<Array<Maybe<ProjectUserType>>>;
  reasonForSurvey?: Maybe<Scalars['String']['output']>;
  /** The reference number of the project. */
  referenceNumber?: Maybe<Scalars['String']['output']>;
  /** The responsible map to users */
  responsible?: Maybe<UserInfoType>;
  /** The user responsible for measuring */
  responsibleMeasuring?: Maybe<UserInfoType>;
  /** The user responsible for surveying */
  responsibleSurveying?: Maybe<UserInfoType>;
  riskAnalysisEstablished: Scalars['Boolean']['output'];
  /** Show measuring point curves for this project? */
  showCurves?: Maybe<Scalars['Boolean']['output']>;
  showMap: Scalars['Boolean']['output'];
  /** The date the project started */
  startDate?: Maybe<Scalars['DateTime']['output']>;
};


export type ProjectBlastsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectListMeasuringDataArgs = {
  blastId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<Scalars['String']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  maxVal?: InputMaybe<Scalars['Float']['input']>;
  measuringDataId?: InputMaybe<Scalars['ID']['input']>;
  measuringPointId?: InputMaybe<Scalars['ID']['input']>;
  measuringPointIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  minVal?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  showItemsConnectedToBlast?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<MeasuringDataSortBy>;
  sortDirection?: InputMaybe<SortDirection>;
  subProjectNumber?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectMeasuringCardsArgs = {
  includeDormant?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectMeasuringDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  blastId?: InputMaybe<Scalars['ID']['input']>;
  channelType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  measuringDataId?: InputMaybe<Scalars['Int']['input']>;
  measuringDataIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  measuringPointId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<MeasuringDataSortBy>;
  sortDirection?: InputMaybe<SortDirection>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectMeasuringPointsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectNoiseDateSummariesArgs = {
  externalReduction?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  measuringPointId?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  transientFtpId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection from an object to a list of objects of type `Project`. */
export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<ProjectEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<Project>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Project`. */
export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Project>;
};

export type ProjectInput = {
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  apiInUse?: InputMaybe<Scalars['Boolean']['input']>;
  assistant?: InputMaybe<Scalars['Int']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  contact: Scalars['Int']['input'];
  county: Scalars['String']['input'];
  crs?: InputMaybe<Scalars['Int']['input']>;
  customer: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  localManager?: InputMaybe<Scalars['Int']['input']>;
  manageBlasts?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  office: Scalars['Int']['input'];
  reasonForSurvey?: InputMaybe<Scalars['String']['input']>;
  responsible: Scalars['Int']['input'];
  responsibleMeasuring?: InputMaybe<Scalars['Int']['input']>;
  responsibleSurveying?: InputMaybe<Scalars['Int']['input']>;
  riskAnalysisEstablished?: InputMaybe<Scalars['Boolean']['input']>;
  showCurves?: InputMaybe<Scalars['Boolean']['input']>;
  showMap?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['String']['input'];
};

export type ProjectNoteType = {
  __typename?: 'ProjectNoteType';
  /** The date and time the note was created */
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  /** The Id of the note. */
  id: Scalars['Int']['output'];
  /** If the note is active */
  isActive: Scalars['Boolean']['output'];
  /** The content of the note */
  note: Scalars['String']['output'];
  /** The user that created the note */
  user?: Maybe<UserInfoType>;
};

export type ProjectNotificationDetailInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  notification?: InputMaybe<Scalars['String']['input']>;
  notificationFlag?: InputMaybe<Scalars['Int']['input']>;
  notificationPoints?: InputMaybe<Scalars['String']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectNotificationInput = {
  allowedMeasuringPoints?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  notification: Scalars['String']['input'];
  notificationFlag: Scalars['Int']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowModifyBlast: Scalars['Boolean']['input'];
  allowedMeasuringPoints?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isPropertyOwner?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
  projectNotificationDetails?: InputMaybe<Array<InputMaybe<ProjectNotificationDetailInput>>>;
  projectNotificationsUpdated: Scalars['Boolean']['input'];
  projectUserId?: InputMaybe<Scalars['Int']['input']>;
  projectUserUpdated: Scalars['Boolean']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
  userUpdated: Scalars['Boolean']['input'];
};

export type ProjectUserType = {
  __typename?: 'ProjectUserType';
  /** The field to identify if a project user can add/modify blast */
  allowModifyBlast: Scalars['Boolean']['output'];
  /** The projectUsers measuring points */
  allowedMeasuringPoints?: Maybe<Scalars['String']['output']>;
  /** The email for the user. */
  email?: Maybe<Scalars['String']['output']>;
  /** The row_number() id */
  id: Scalars['Int']['output'];
  invitationMailStatus?: Maybe<Scalars['String']['output']>;
  /** Is the projectUser a property owner? */
  isPropertyOwner: Scalars['Boolean']['output'];
  /** Limit Value on project notification */
  limit?: Maybe<Scalars['Float']['output']>;
  /** The projectUser last modification date */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The projectNotification name */
  name: Scalars['String']['output'];
  /** The projectNotification notification */
  notification?: Maybe<Scalars['String']['output']>;
  /** An integer describing which notifications the recipient should receive */
  notificationFlag?: Maybe<Scalars['Int']['output']>;
  /** The projectNotification measuring points */
  notificationPoints?: Maybe<Scalars['String']['output']>;
  /** The phone number for the user. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The Id for the project notification */
  projectNotificationId?: Maybe<Scalars['Int']['output']>;
  /** The Id for the project user */
  projectUserId?: Maybe<Scalars['Int']['output']>;
  /** The user role */
  role?: Maybe<Scalars['String']['output']>;
  /** The new overridden role */
  roleOverride?: Maybe<Scalars['String']['output']>;
  /** A string describing the projectUser type (ie. is it a projectUser or a projectNotification or both) */
  type?: Maybe<Scalars['String']['output']>;
  /** The user id */
  userId: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  azureWebAppStatus?: Maybe<Scalars['String']['output']>;
  businessLog?: Maybe<ListBusinessLogDataType>;
  compilationDocuments?: Maybe<Array<Maybe<DocumentType>>>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  customers?: Maybe<Array<Maybe<CustomerType>>>;
  document?: Maybe<DocumentType>;
  documentFolders?: Maybe<DocumentFoldersType>;
  explodeJournal?: Maybe<ExplodeJournalType>;
  faqDocument?: Maybe<FaqDocumentType>;
  faqDocuments?: Maybe<Array<Maybe<FaqDocumentType>>>;
  /** Get user's favourite projects */
  favouriteProjects?: Maybe<ProjectConnection>;
  fredStatus?: Maybe<FredStatusConnection>;
  instrument?: Maybe<InstrumentDataType>;
  instruments?: Maybe<Array<Maybe<InstrumentType>>>;
  invoiceExportLogs?: Maybe<InvoiceExportLogsType>;
  invoiceItems?: Maybe<ListInvoiceItemsType>;
  noiseData?: Maybe<Array<Maybe<NoiseDataType>>>;
  noiseSetting?: Maybe<NoiseSettingType>;
  office?: Maybe<OfficeType>;
  offices?: Maybe<Array<Maybe<OfficeType>>>;
  project?: Maybe<Project>;
  /** Get projects */
  projects?: Maybe<ProjectConnection>;
  roles?: Maybe<Array<Maybe<RoleType>>>;
  search?: Maybe<Array<Maybe<Project>>>;
  searchDocument?: Maybe<Array<Maybe<DocumentType>>>;
  sentNotifications?: Maybe<ListSentNotificationOutputType>;
  sigicomStatus?: Maybe<SigicomStatusConnection>;
  users?: Maybe<Array<Maybe<UserType>>>;
};


export type QueryAzureWebAppStatusArgs = {
  resourceGroupName?: InputMaybe<Scalars['String']['input']>;
  webAppName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBusinessLogArgs = {
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompilationDocumentsArgs = {
  projectReference?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactsArgs = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomersArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryExplodeJournalArgs = {
  blastId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFaqDocumentArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFaqDocumentsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFavouriteProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDormant?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFredStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInstrumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInstrumentsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInvoiceExportLogsArgs = {
  invoiceEndDate?: InputMaybe<Scalars['String']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoiceItemsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['String']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<InvoiceItemsSortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryNoiseDataArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  measuringPointId?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNoiseSettingArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOfficeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProjectArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDormant?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchArgs = {
  dormant?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};


export type QuerySearchDocumentArgs = {
  searchTerm: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySentNotificationsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectReference: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySigicomStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  onlyInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoleType = {
  __typename?: 'RoleType';
  /** The role display name */
  displayName: Scalars['String']['output'];
  /** A graphql Id */
  id: Scalars['Int']['output'];
  /** The role name */
  name: Scalars['String']['output'];
};

export type ScrubPersonalInfoInput = {
  id: Scalars['Int']['input'];
};

export type SentNotificationType = {
  __typename?: 'SentNotificationType';
  id?: Maybe<Scalars['Int']['output']>;
  sent?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  tableData?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** A connection from an object to a list of objects of type `SigicomStatus`. */
export type SigicomStatusConnection = {
  __typename?: 'SigicomStatusConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<SigicomStatusEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<SigicomStatusType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `SigicomStatus`. */
export type SigicomStatusEdge = {
  __typename?: 'SigicomStatusEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SigicomStatusType>;
};

export type SigicomStatusType = {
  __typename?: 'SigicomStatusType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  measuringCard?: Maybe<MeasuringCardType>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  processed: Scalars['Boolean']['output'];
  project?: Maybe<Project>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SummariesType = {
  __typename?: 'SummariesType';
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isHoliday: Scalars['Boolean']['output'];
  summary?: Maybe<SummaryType>;
  transients?: Maybe<Array<Maybe<TransientType>>>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SummaryType = {
  __typename?: 'SummaryType';
  channelId: Scalars['Int']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  dayLAEq?: Maybe<Scalars['Float']['output']>;
  dayLAFMax?: Maybe<Scalars['Float']['output']>;
  eveningLAEq?: Maybe<Scalars['Float']['output']>;
  eveningLAFMax?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  l24?: Maybe<Scalars['Float']['output']>;
  lDen?: Maybe<Scalars['Float']['output']>;
  measuringCardId: Scalars['Int']['output'];
  nightLAEq?: Maybe<Scalars['Float']['output']>;
  nightLAFMax?: Maybe<Scalars['Float']['output']>;
  placement: Scalars['Int']['output'];
};

export type TopLevelDocumentFolderType = {
  __typename?: 'TopLevelDocumentFolderType';
  allowUploads: Scalars['Boolean']['output'];
  assignment: Scalars['Int']['output'];
  children?: Maybe<Array<Maybe<DocumentFolderType>>>;
  defaultVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type TransientType = {
  __typename?: 'TransientType';
  channelId: Scalars['Int']['output'];
  curveData: Scalars['String']['output'];
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  ftpId: Scalars['Int']['output'];
};

export type UpdateCoordinatesForProjectInput = {
  crs: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type UserInfoType = {
  __typename?: 'UserInfoType';
  backgroundColor: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  linkColor: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phonenumber?: Maybe<Scalars['String']['output']>;
};

export type UserInput = {
  email: Scalars['String']['input'];
  exportToQBIS?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phonenumber: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type UserType = {
  __typename?: 'UserType';
  backgroundColor: Scalars['String']['output'];
  email: Scalars['String']['output'];
  exportToQBIS: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invitationMailStatus?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isInviteSent: Scalars['Boolean']['output'];
  lastLoggedIn?: Maybe<Scalars['Date']['output']>;
  linkColor: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phonenumber?: Maybe<Scalars['String']['output']>;
  /** Projects where this user is a project user */
  projects?: Maybe<Array<Maybe<Project>>>;
  role: Scalars['String']['output'];
};


export type UserTypeProjectsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetBlastsQueryVariables = Exact<{
  referenceNumber: Scalars['String']['input'];
}>;


export type GetBlastsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, blasts?: Array<{ __typename?: 'BlastType', id: number, dateTime?: string | null, latitude: number, longitude: number } | null> | null } | null };

export type GetMeasuringPointLocationsQueryVariables = Exact<{
  referenceNumber: Scalars['String']['input'];
}>;


export type GetMeasuringPointLocationsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, measuringPoints?: Array<{ __typename?: 'MeasuringPointType', id: number, number: number, longitude?: number | null, latitude?: number | null } | null> | null } | null };

export type GetProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: number, referenceNumber?: string | null, name: string, office?: { __typename?: 'OfficeType', id: number, name?: string | null } | null, projectUsers?: Array<{ __typename?: 'ProjectUserType', email?: string | null, notificationFlag?: number | null, notificationPoints?: string | null } | null> | null, measuringCards?: Array<{ __typename?: 'MeasuringCardType', id: number, instrumentBattery?: number | null, allChannelsOK: boolean, instrumentCapacity?: number | null, validSetup: boolean, lastStatusActivity?: string | null, lastTriggerActivity?: string | null, validFrom?: string | null, validTo?: string | null, version?: string | null, lastNumber: number, rssi?: number | null, unMount: boolean, noService: boolean, channelsStatus?: string | null, statusErrorReasons?: string | null, triggerErrorReasons?: string | null, batteryDaysLeft?: number | null, instrument?: { __typename?: 'InstrumentType', id: number, model: string, name: string, calibrationDate?: string | null, criticalErrors?: Array<number> | null } | null, channels?: Array<{ __typename?: 'MeasuringCardChannelType', type?: string | null, measuringPoint?: { __typename?: 'MeasuringPointType', id: number, address: string, number: number, latitude?: number | null, longitude?: number | null, mountedInside?: boolean | null, mountedInsideNumber?: string | null } | null } | null> | null } | null> | null } | null } | null> | null } | null };

export type GetFredStatusQueryVariables = Exact<{
  createdAfter: Scalars['String']['input'];
}>;


export type GetFredStatusQuery = { __typename?: 'Query', fredStatus?: { __typename?: 'FredStatusConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'FredStatusEdge', node?: { __typename?: 'FredStatusType', id: number, processed: boolean, createdAt?: string | null, project?: { __typename?: 'Project', id: number } | null, measuringCard?: { __typename?: 'MeasuringCardType', id: number } | null } | null } | null> | null } | null };

export type FavouriteProjects2QueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FavouriteProjects2Query = { __typename?: 'Query', favouriteProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: number, name: string, referenceNumber?: string | null, isFavourite: boolean, county?: string | null, startDate?: string | null, endDate?: string | null, manageBlasts?: boolean | null, customer?: { __typename?: 'CustomerType', id?: number | null, name?: string | null } | null, office?: { __typename?: 'OfficeType', id: number, name?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type CreateUpdateInstrumentMutationVariables = Exact<{
  instrumentInput: InstrumentInputType;
}>;


export type CreateUpdateInstrumentMutation = { __typename?: 'Mutation', createUpdateInstrument?: boolean | null };

export type GetInstrumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstrumentsQuery = { __typename?: 'Query', instruments?: Array<{ __typename?: 'InstrumentType', id: number, name: string, model: string, isActive: boolean, calibrationDate?: string | null, lastStatusAt?: string | null, latestLocation?: { __typename?: 'InstrumentLocationType', latitude: number, longitude: number, receivedAt: string } | null } | null> | null };

export type GetInstrumentDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetInstrumentDetailsQuery = { __typename?: 'Query', instrument?: { __typename?: 'InstrumentDataType', id: number, isActive: boolean, name: string, model: string, channels: number, calibrationDate?: string | null, lastStatusAt?: string | null, currentConfiguration?: string | null, nextConfiguration?: string | null, versions?: string | null } | null };

export type GetMeasuringCardsPointsAndInstrumentsQueryVariables = Exact<{
  projectReference: Scalars['String']['input'];
}>;


export type GetMeasuringCardsPointsAndInstrumentsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', measuringPoints?: Array<{ __typename?: 'MeasuringPointType', id: number, number: number } | null> | null, measuringCards?: Array<{ __typename?: 'MeasuringCardType', id: number, validFrom?: string | null, validTo?: string | null, instrument?: { __typename?: 'InstrumentType', id: number, name: string } | null, channels?: Array<{ __typename?: 'MeasuringCardChannelType', id: number, measuringPointId?: number | null } | null> | null } | null> | null } | null };

export type GetInstrumentsIdAndNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstrumentsIdAndNameQuery = { __typename?: 'Query', instruments?: Array<{ __typename?: 'InstrumentType', id: number, name: string } | null> | null };

export type GetMeasuringPointLocationsNewQueryVariables = Exact<{
  referenceNumber: Scalars['String']['input'];
}>;


export type GetMeasuringPointLocationsNewQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, longitude?: number | null, latitude?: number | null, measuringPoints?: Array<{ __typename?: 'MeasuringPointType', id: number, number: number, longitude?: number | null, latitude?: number | null } | null> | null } | null };

export type GetProjectLocationQueryVariables = Exact<{
  referenceNumber: Scalars['String']['input'];
}>;


export type GetProjectLocationQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, latitude?: number | null, longitude?: number | null } | null };

export type GetMapDataQueryVariables = Exact<{
  referenceNumber: Scalars['String']['input'];
}>;


export type GetMapDataQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, measuringPoints?: Array<{ __typename?: 'MeasuringPointType', id: number, number: number, longitude?: number | null, latitude?: number | null, address: string, crs?: number | null, z?: number | null, v10?: number | null, v1?: number | null, v2?: number | null, noise?: number | null, underground?: string | null, typeOfWork: string, fixedBenchmark?: number | null, airblast?: number | null, isAddedOnMap?: boolean | null } | null> | null, measuringCards?: Array<{ __typename?: 'MeasuringCardType', id: number, validFrom?: string | null, validTo?: string | null, isActive: boolean, channels?: Array<{ __typename?: 'MeasuringCardChannelType', id: number, channel: number, type?: string | null, sensor?: string | null, hiredFrom?: string | null, hiredTo?: string | null, measuringCardId: number, measuringPointId?: number | null, isActive: boolean } | null> | null } | null> | null } | null };

export type UpdateMeasuringDataMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  measuringDataId: Scalars['Int']['input'];
  isService: Scalars['Boolean']['input'];
}>;


export type UpdateMeasuringDataMutation = { __typename?: 'Mutation', updateMeasuringData?: string | null };

export type CurveDataQueryVariables = Exact<{
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  measuringPointId?: InputMaybe<Scalars['Int']['input']>;
  transientFtpId?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
}>;


export type CurveDataQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, noiseDateSummaries?: { __typename?: 'NoiseDateSummariesType', id: number, summaries?: Array<{ __typename?: 'SummariesType', id: number, transients?: Array<{ __typename?: 'TransientType', dateTime?: string | null, curveData: string } | null> | null } | null> | null } | null } | null };

export type GetMeasuringPointsQueryVariables = Exact<{
  referenceNumber: Scalars['String']['input'];
}>;


export type GetMeasuringPointsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, measuringPoints?: Array<{ __typename?: 'MeasuringPointType', id: number, number: number, address: string } | null> | null } | null };


export const GetBlastsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBlasts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referenceNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"blasts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dateTime"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]} as unknown as DocumentNode<GetBlastsQuery, GetBlastsQueryVariables>;
export const GetMeasuringPointLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMeasuringPointLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referenceNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"measuringPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}}]}}]}}]} as unknown as DocumentNode<GetMeasuringPointLocationsQuery, GetMeasuringPointLocationsQueryVariables>;
export const GetProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"office"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"notificationFlag"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPoints"}}]}},{"kind":"Field","name":{"kind":"Name","value":"measuringCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"instrumentBattery"}},{"kind":"Field","name":{"kind":"Name","value":"allChannelsOK"}},{"kind":"Field","name":{"kind":"Name","value":"instrumentCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"validSetup"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusActivity"}},{"kind":"Field","name":{"kind":"Name","value":"lastTriggerActivity"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"lastNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rssi"}},{"kind":"Field","name":{"kind":"Name","value":"unMount"}},{"kind":"Field","name":{"kind":"Name","value":"noService"}},{"kind":"Field","name":{"kind":"Name","value":"instrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calibrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"criticalErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"measuringPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"mountedInside"}},{"kind":"Field","name":{"kind":"Name","value":"mountedInsideNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"channelsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"statusErrorReasons"}},{"kind":"Field","name":{"kind":"Name","value":"triggerErrorReasons"}},{"kind":"Field","name":{"kind":"Name","value":"batteryDaysLeft"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetFredStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFredStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAfter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fredStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createdAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAfter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"measuringCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFredStatusQuery, GetFredStatusQueryVariables>;
export const FavouriteProjects2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FavouriteProjects2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favouriteProjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"referenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isFavourite"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"manageBlasts"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"office"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<FavouriteProjects2Query, FavouriteProjects2QueryVariables>;
export const CreateUpdateInstrumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUpdateInstrument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instrumentInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InstrumentInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUpdateInstrument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"instrumentInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instrumentInput"}}}]}]}}]} as unknown as DocumentNode<CreateUpdateInstrumentMutation, CreateUpdateInstrumentMutationVariables>;
export const GetInstrumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"calibrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"receivedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetInstrumentsQuery, GetInstrumentsQueryVariables>;
export const GetInstrumentDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInstrumentDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instrument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"calibrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusAt"}},{"kind":"Field","name":{"kind":"Name","value":"currentConfiguration"}},{"kind":"Field","name":{"kind":"Name","value":"nextConfiguration"}},{"kind":"Field","name":{"kind":"Name","value":"versions"}}]}}]}}]} as unknown as DocumentNode<GetInstrumentDetailsQuery, GetInstrumentDetailsQueryVariables>;
export const GetMeasuringCardsPointsAndInstrumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMeasuringCardsPointsAndInstruments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectReference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referenceNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectReference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measuringPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"measuringCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDormant"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"includeInactive"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"instrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"measuringCardChannelType"},"value":{"kind":"StringValue","value":"ALL","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"measuringPointId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMeasuringCardsPointsAndInstrumentsQuery, GetMeasuringCardsPointsAndInstrumentsQueryVariables>;
export const GetInstrumentsIdAndNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInstrumentsIdAndName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetInstrumentsIdAndNameQuery, GetInstrumentsIdAndNameQueryVariables>;
export const GetMeasuringPointLocationsNewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMeasuringPointLocationsNew"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referenceNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"measuringPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}}]}}]}}]} as unknown as DocumentNode<GetMeasuringPointLocationsNewQuery, GetMeasuringPointLocationsNewQueryVariables>;
export const GetProjectLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referenceNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]} as unknown as DocumentNode<GetProjectLocationQuery, GetProjectLocationQueryVariables>;
export const GetMapDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMapData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referenceNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"measuringPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"crs"}},{"kind":"Field","name":{"kind":"Name","value":"z"}},{"kind":"Field","name":{"kind":"Name","value":"v10"}},{"kind":"Field","name":{"kind":"Name","value":"v1"}},{"kind":"Field","name":{"kind":"Name","value":"v2"}},{"kind":"Field","name":{"kind":"Name","value":"noise"}},{"kind":"Field","name":{"kind":"Name","value":"underground"}},{"kind":"Field","name":{"kind":"Name","value":"typeOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"fixedBenchmark"}},{"kind":"Field","name":{"kind":"Name","value":"airblast"}},{"kind":"Field","name":{"kind":"Name","value":"isAddedOnMap"}}]}},{"kind":"Field","name":{"kind":"Name","value":"measuringCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDormant"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"measuringCardChannelType"},"value":{"kind":"StringValue","value":"ALL","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sensor"}},{"kind":"Field","name":{"kind":"Name","value":"hiredFrom"}},{"kind":"Field","name":{"kind":"Name","value":"hiredTo"}},{"kind":"Field","name":{"kind":"Name","value":"measuringCardId"}},{"kind":"Field","name":{"kind":"Name","value":"measuringPointId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMapDataQuery, GetMapDataQueryVariables>;
export const UpdateMeasuringDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMeasuringData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"measuringDataId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isService"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMeasuringData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"measuringDataId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"measuringDataId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isService"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isService"}}}]}]}}]} as unknown as DocumentNode<UpdateMeasuringDataMutation, UpdateMeasuringDataMutationVariables>;
export const CurveDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurveData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"measuringPointId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transientFtpId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referenceNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"noiseDateSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"measuringPointId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"measuringPointId"}}},{"kind":"Argument","name":{"kind":"Name","value":"transientFtpId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transientFtpId"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateTime"}},{"kind":"Field","name":{"kind":"Name","value":"curveData"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurveDataQuery, CurveDataQueryVariables>;
export const GetMeasuringPointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMeasuringPoints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referenceNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"measuringPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]} as unknown as DocumentNode<GetMeasuringPointsQuery, GetMeasuringPointsQueryVariables>;